<template>
  <div :class="`progress-wrapper ${value}`">
    {{ displayText ? $t(`classes.filter_menu.${value}`) : ''}}
    <el-progress
      :percentage="setProgressObject(value).percentage"
      :show-text="false"
      :status="setProgressObject(value).status"
    />
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      displayText: {
        type: Boolean,
        default: true
      },
      percentage: {
        type: Number,
        default: 75,
      }
    },
    methods: {
      setProgressObject(status) {
        if (status === 'active') {
          return { status: 'warning', percentage: this.percentage }
        } else if (status === 'finished') {
          return { status: 'success', percentage: 100 }
        }

        return { status: 'exception', percentage: 0 }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";
  .progress-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: $darker-blue;

    &.draft {
      opacity: 0.5;
    }
    .el-progress {
      min-width: 116px;
      margin-right: 8px;
      &.is-warning::v-deep .el-progress-bar__inner {
        background-color: $purple;
      }
      &.is-success::v-deep .el-progress-bar__inner {
        background-color: $success;
      }
      &::v-deep {
        .el-progress-bar__inner,
        .el-progress-bar__outer {
          border-radius: 0;
        }
        .el-progress-bar__outer {
          height: 13px !important; // This important is need because elementui is adding an inline height style
          background-color: $light-blue;
        }
      }
    }
  }

</style>
